module.exports = __webpack_public_path__ + "il.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/il.svg
// module id = 863
// module chunks = 0